export default "__VITE_ASSET__CCiArwYD__"